interface UpdateSplashProps {
  message?: string;
}

/**
 * Full-screen cover shown while the old build's caches are cleared and the page reloads.
 * Self-contained on purpose: it renders above the error boundary, outside Metronic's
 * LayoutProvider, so it can't use the layout splash screen.
 */
const UpdateSplash = ({ message = "Updating to the latest version..." }: UpdateSplashProps) => (
  <div
    role="status"
    aria-live="polite"
    className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-center bg-body"
    style={{ zIndex: 9999 }}
  >
    <div className="text-center">
      <div className="spinner-border text-primary mb-3" aria-hidden="true" />
      <div className="text-primary fs-5 fw-semibold mb-2">{message}</div>
      <div className="text-muted small">This will only take a moment...</div>
    </div>
  </div>
);

export default UpdateSplash;
